import { useCallback, useEffect, useState } from 'react';
import { getTreatmentPlanPrefill } from 'api/insuranceBilling';
import { TTreatmentPlanPrefill } from 'types/insuranceBilling';

const useTreatmentPlanInfo = (
    businessType?: string,
    businessId?: number,
    providerId?: number,
): [TTreatmentPlanPrefill | null, boolean, () => void] => {
    const [data, setData] = useState<TTreatmentPlanPrefill | null>(null);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(async () => {
        if (!businessType || !businessId) return;
        setLoading(true);
        try {
            const res = await getTreatmentPlanPrefill(businessType, businessId, providerId);
            if (res && !res.error) {
                setData(res.data?.data || null);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [businessType, businessId, providerId]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default useTreatmentPlanInfo;
